import { INSPECTION_SCORE_TYPE, TInspectionScoreType, TRollStatus } from '@monorepo/types';

type TFabricRollStatusTagKey =
  | 'fabric_inspection_change_roll_status.tagGreen'
  | 'fabric_inspection_change_roll_status.tagYellow'
  | 'fabric_inspection_change_roll_status.tagRed';

type TFabricRollStatusTagBg = 'fabric-status-green' | 'fabric-status-yellow' | 'fabric-status-red';

export type TFabricRollStatusTableCell =
  | { variant: 'plain'; label: string }
  | { variant: 'tag'; labelKey: TFabricRollStatusTagKey; tagBgColor: TFabricRollStatusTagBg };

export function fabricInspectionRollStatusPlainLabel(status: TRollStatus): string {
  switch (status) {
    case 'SELECTED':
      return 'SELECTED';
    case 'IN_PROGRESS':
      return 'IN-PROGRESS';
    case 'NOT_STARTED':
      return 'NOT STARTED';
    default:
      return status;
  }
}

export function fabricInspectionRollStatusTableCell(status: TRollStatus): TFabricRollStatusTableCell {
  switch (status) {
    case 'COMMERCIALLY_APPROVED':
      return {
        variant: 'tag',
        labelKey: 'fabric_inspection_change_roll_status.tagYellow',
        tagBgColor: 'fabric-status-yellow',
      };
    case 'FAILED':
      return {
        variant: 'tag',
        labelKey: 'fabric_inspection_change_roll_status.tagRed',
        tagBgColor: 'fabric-status-red',
      };
    case 'PASSED':
      return {
        variant: 'tag',
        labelKey: 'fabric_inspection_change_roll_status.tagGreen',
        tagBgColor: 'fabric-status-green',
      };
    case 'SELECTED':
      return { variant: 'plain', label: 'SELECTED' };
    case 'IN_PROGRESS':
      return { variant: 'plain', label: 'IN-PROGRESS' };
    case 'NOT_STARTED':
      return { variant: 'plain', label: 'NOT STARTED' };
  }
}

type TFabricInspectionScoreHeaderKey =
  | 'fabric_inspection_transaction_roll_listing.scoreHeaderDefault'
  | 'fabric_inspection_transaction_roll_listing.scoreHeaderSquareYard'
  | 'fabric_inspection_transaction_roll_listing.scoreHeaderSquareMeter'
  | 'fabric_inspection_transaction_roll_listing.scoreHeaderMeterYard';

export function fabricInspectionScoreHeaderKey(
  useTagFlow: boolean,
  inspectionScoreType: TInspectionScoreType | null,
): TFabricInspectionScoreHeaderKey {
  if (!useTagFlow) {
    return 'fabric_inspection_transaction_roll_listing.scoreHeaderDefault';
  }

  switch (inspectionScoreType) {
    case INSPECTION_SCORE_TYPE.SQUARE_YARD_SCORE:
      return 'fabric_inspection_transaction_roll_listing.scoreHeaderSquareYard';
    case INSPECTION_SCORE_TYPE.SQUARE_METER_SCORE:
      return 'fabric_inspection_transaction_roll_listing.scoreHeaderSquareMeter';
    case INSPECTION_SCORE_TYPE.METER_YARD_SCORE:
      return 'fabric_inspection_transaction_roll_listing.scoreHeaderMeterYard';
    default:
      return 'fabric_inspection_transaction_roll_listing.scoreHeaderDefault';
  }
}
